import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Owner, WorkSpaceUserName } from "../../../model/ItemModel";
import { SetOwner } from "../../../services/Item/ItemServicesCRUD";
import { GetItemGroup, GetItemUser, GetOneItem } from "../../../services/Item/ItemServicesGet";
import { GetOrganizationUserName } from "../../../services/OrganizationServices";
import { CircularProgress, SelectChangeEvent } from '@mui/material';
import { User } from '../../../model/OrganizationModel';
import EditFolderInformation from './components/EditFolder/EditFolderInformation';
import { UserPermission } from '../../../model/UserModel';
import { GroupPermission } from '../../../model/GroupModel';
import EditFolderPrivilegeListing from './components/EditFolder/EditFolderPrivilegeListing';
import EditFolderPrivilegeHandler from './components/EditFolder/EditFolderPrivilegeHandler';
import EditFolderWrapper from './components/EditFolder/EditFolderWrapper';


export interface EditFolderOpen{
    idMongo: string;
    nameChanged: string;
    ownerId?: string;
    ownerName?: string;
    sensitivity?: number;
    notificationEmail?:boolean;
}

export interface EditFolderParams{
    editFolderOpen: EditFolderOpen;
    saveOkMetod: () => void;
    nameOrg: string;
}

const EditFolder = (props: EditFolderParams) => {
    const { t } = useTranslation(); 
    const [nameChanged, setNameChanged] = useState<string>(props.editFolderOpen.nameChanged); 
    const [messageErrorString, setMessageErrorString] = useState<string>(t("ErroAoSalvar.message"));
    const [isMessageError, setMessageError] = useState<boolean>(false);
    const [wait, setWait] = useState<boolean>(false);
    const { idWorkspace, nameOrg, idFolder } = useParams();
    const [selectNotification, setSelectNotification] = useState<boolean>(false);
    const [folder, setFolder] = useState<WorkSpaceUserName | undefined>(undefined);
    const [isLoadingFolder, setIsLoadingFolder] = useState<boolean>(false);
    const [newUserSearch, setNewUserSearch] = useState<string>("");
    const [newSensitivity, setNewSensitivity] = useState<number>(0);
    const [admOrganizationUsers, setAdmOrganizationUsers] = useState<User[]>([]);
    const [usersPermission, setUsersPermission] = useState<UserPermission[]>([]);
    const [groupsPermission, setGroupsPermission] = useState<GroupPermission[]>([]);
    const [value, setValue] = useState<number>(0);

    useEffect(() => {
        GetItemIdAsync();
        GetAdmOrganizationUsers();
        GetAllUsersAsync();
        GetAllGroupsAsync();
    }, []);

    async function GetItemIdAsync() {
        setIsLoadingFolder(true);

        if (props.editFolderOpen.idMongo) {
            try {
                const response = await GetOneItem(props.editFolderOpen.idMongo);
                console.log(response)
                setFolder(response);
                setNewSensitivity(response?.sensitivity!);
                setNewUserSearch(response?.ownerId!);
                setSelectNotification(response.notificationEmail);
                setNameChanged(response?.name!);
            } catch (err: any) {
                setMessageErrorString(err.response.data);
            } 
        }
    }

    async function GetAdmOrganizationUsers() {
        setIsLoadingFolder(true);
        try {
            const response = await GetOrganizationUserName(nameOrg!, newUserSearch);
            setAdmOrganizationUsers(response);
        } catch (err: any) {
                setMessageErrorString(err.response.data);
            } 
    }

    async function GetAllUsersAsync() {
        setIsLoadingFolder(true);
        try {
            const response = await GetItemUser(props.editFolderOpen.idMongo!, 0, 999);
            setUsersPermission(response.permissions);
        } catch (err: any) {
            setMessageErrorString(err.response.data);
        } 
    }

    async function GetAllGroupsAsync() {
        setIsLoadingFolder(true);
        try {
            const response = await GetItemGroup(props.editFolderOpen.idMongo!, 0, 0);
            setGroupsPermission(response);
        } catch (err: any) {
            setMessageErrorString(err.response.data);
        } finally {
            setIsLoadingFolder(false);
        }
    }

    function handleUser(e: SelectChangeEvent): void {
        setNewUserSearch(e.target.value);
    }

    function handleSensitivity(e: SelectChangeEvent): void {
        setNewSensitivity(Number(e.target.value));
    }

    const UpdateOwner = () => {
        let owner:Owner = {
            idFolder:props.editFolderOpen.idMongo,
            idNewOwner:newUserSearch,
            NewName:nameChanged,
            sensitivity:newSensitivity,
            idItem:props.editFolderOpen.idMongo,
            notificationEmail:selectNotification
        };
        SetOwner(owner)
        .then(() => {
            props.saveOkMetod();
        })
        .catch((error) => {
            if( error.response && error.response.data && typeof error.response.data  === 'string'){
                setMessageErrorString(error.response.data);
            }
            else
            {
                setMessageErrorString(t("ErroAoSalvar.message"));
            }
            setWait(false);
            setMessageError(true);
        })
    }

    if (isLoadingFolder) {
        return <CircularProgress variant='indeterminate' />
    }

    return (    
        <EditFolderWrapper>
            <EditFolderInformation 
                admOrganizationUsers={admOrganizationUsers}
                folderName={folder?.name!}
                handleSensitivity={handleSensitivity}
                handleUser={handleUser}
                newSensitivity={newSensitivity}
                newUserSearch={newUserSearch}
                updateInformation={UpdateOwner}
                setSelectNotification={setSelectNotification}
                selectNotification={selectNotification}
                setNameChanged={setNameChanged}
                nameChanged={nameChanged}
                hasFather={folder?.fatherId != undefined}
                ownerId={folder?.ownerId!}
                setNewUserSearch={setNewUserSearch}
            />
            <EditFolderPrivilegeListing 
                groupPermission={groupsPermission}
                setValue={setValue}
                usersPermission={usersPermission}
                value={value}
            />
            { !isLoadingFolder && folder && folder.fatherId === undefined && (
                <EditFolderPrivilegeHandler 
                    idFolder={props.editFolderOpen.idMongo!}
                    idWorkspace={idWorkspace!}
                    nameOrg={nameOrg!}
                />
            ) }
        </EditFolderWrapper>
    )

}

export default EditFolder;

